import React from 'react'
import PropTypes from 'prop-types'

import './SVG.scss'

const SVG = ({ children, className, height = 24, width = 24, ...props }) => (
  <img
    className={`SVGContainer ${className}`}
    {...props}
    src={children}
    alt="logo"
    height={height}
    width={width}
  />
)

SVG.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  children: PropTypes.node
}

SVG.defaultProps = {
  className: '',
  height: 24,
  width: 24,
  children: null
}

export default SVG
